import { render, staticRenderFns } from "./idp-examination.vue?vue&type=template&id=51de7b66"
import script from "./idp-examination.vue?vue&type=script&lang=js"
export * from "./idp-examination.vue?vue&type=script&lang=js"
import style0 from "./idp-examination.vue?vue&type=style&index=0&id=51de7b66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports